module.exports = __webpack_public_path__ + "static/megaphone-dark-c8e8435e6b9118403a2e37eef910d525.gif";